import { Box } from "@mui/material";
import React, { useContext } from "react";
import { PatientContext } from "../../../contexts/PatientContext.tsx";
import VisitsSkeleton from "../skeletons/VisitsSkeleton.js";
import VisitsInfo from "./VisitsInfo.tsx";

export default function Visits({ loading }: { loading: boolean }) {
  const { encounters } = useContext(PatientContext)!;
  if (!encounters || encounters.length === 0 || loading) {
    return <VisitsSkeleton />;
  }
  return (
    <div className="visits-card">
      <Box
        sx={{
          display: "flex",
          width: 1,
          flexDirection: "column",
          marginTop: "10px",
        }}
      >
        <VisitsInfo />
      </Box>
    </div>
  );
}
